/** 动态选项卡业务 */
export default{
    namespaced: true,
    state:()=>({
        openTab:[],//所有打开的选项卡即打开的路由，数据格式{title:'页面名称',path:'/页面路由'}
        activeIndex:'/appmain/home',//激活的选项卡
    }),
    mutations:{
        /** 添加选项卡 */
        ADD_TAB(state,params){
            state.openTab.push(params)
        },
        /** 移除选项卡 */
        REMOVE_TAB(state,params){
            state.openTab.splice(state.openTab.findIndex(item=>item.path===params),1)
        },
        /** 激活选项卡 */
        ACTIVE_TAB(state,params){
            state.activeIndex=params
        },
        /* 登出清空vuex状态 */
        LOGIN_OUT(state){
            state.openTab=[]
            state.activeIndex='/appmain/home'

        },

    },
    actions:{},
    getters:{
        /** 返回查询的path路径在openTab中的下标 */
        FIND_TAB:state=>params=>state.openTab.findIndex(item=>item.path===params)
    },
}